import api from 'ApiConfig';

const teacherService = {
  //Awdiz LMS
  createTeacher: async (teacherData) => {
    return api.post('/admin/create-teacher', teacherData);
  },
  getAllTeacher: async (userId, selectedBranch, departmentId) => {
    return api.post('/admin/get-all-teacher', { userId, selectedBranch, departmentId });
  },
  getAllLocationAllTeacher: async (userId) => {
    return api.post('/admin/get-all-location-all-teacher', { userId });
  },
  updateTeacher: async (payload) => {
    const {
      name: teacherName,
      email: teacherEmail,
      password: teacherPassword,
      _id: teacherId,
    } = payload;
    const updatedPayload = {
      teacherName,
      teacherEmail,
      teacherPassword,
      teacherId,
    };
    return api.post('/admin/update-teacher', updatedPayload);
  },
  getTeacherById: async (teacherId) => {
    return api.post('/admin/get-teacher-by-id', { teacherId });
  },
  assignTeacherToBatches: async (payload) => {
    return api.post('/admin/assign-teacher', payload);
  },
  assignTeacherToMultipleBatches: async (payload) => {
    return api.post('/admin/assign-teacher-multiple-batches', payload);
  },
  //Teacher

  uploadTeachers: async (file, userId, selectedYear) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId);
    formData.append('selectedYear', selectedYear);

    return api.post('/admin/upload-teachers', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  addsingleTeacher: async (formData, userId) => {
    return api.post('/admin/new-teacher', {
      ...formData,
      userId,
    });
  },

  fetchTeachersData: async (userId, page) => {
    return api.post(`/admin/get-teachers-details`, {
      userId,
      page,
    });
  },

  getTeacherAttendance: async (userId, date) => {
    return api.post('/admin/get-teacher-attendance', {
      date,
      userId,
    });
  },

  deactivateTeacherAccount: async (teacherId, orgId, reason) => {
    return api.post('/admin/deactive-teacher-account', {
      teacherId,
      orgId,
      reason,
      accountType: 'Teacher',
    });
  },
  // Leave Requests
  adminLeaveRequests: async (userId, year, month) => {
    return api.post('/admin/get-leave-request', {
      orgId: userId,
      year,
      month,
    });
  },

  reviewLeaveRequest: async (requestId, status, reviewerId) => {
    return api.post('/admin/review-leave-request', {
      requestId,
      status,
      reviewerId,
    });
  },

  // Handling missed punch-in requests
  fetchMissedRequests: async (userId, year, month) => {
    return api.post('/admin/get-teacher-punchins-req-status', {
      orgId: userId,
      year,
      month,
    });
  },

  reviewMissedRequest: async (requestId, status, reviewerId) => {
    return api.post('/admin/review-missed-punch-request', {
      requestId,
      status,
      reviewerId,
    });
  },
};
export default teacherService;
